export enum colorButton {
  WHITE = "bg-white",
  DARK_GREY = "bg-dark-grey",
  DARK_GREY_LIGHT = "bg-light-grey",
  BLUE = "bg-blue-500",
  BLUE_LIGHT = "bg-blue-light",
  TRANSPARENT = "bg-transparent"
}